import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService, AlertService, AutomationService, ConnectionService } from '@app/_services';
import { User } from '@app/_models';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-teams-url-redirect-auth',
  templateUrl: './teams-url-redirect-auth.component.html',
  styleUrls: ['./teams-url-redirect-auth.component.less']
})
export class TeamsUrlRedirectAuthComponent implements OnInit, AfterViewInit {
  user: User;
  auid: string;
  isProgress = true;
  status = true;
  errorMsg = '';

  Dashboard: string;
  constructor(
    private router: Router,
    private accountService: AccountService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private automationservice: AutomationService) {
    this.user = this.accountService.userValue;
  }

  ngOnInit() {
    this.auid = this.activatedRoute.snapshot.params['auid'];
  }
  ngAfterViewInit(): void {
    this.automationservice.activateAutomation(this.auid, this.user, (result) => {
      this.spinner.hide();
      this.isProgress = false;
      if (result.status == true) {
        this.status = true;
      } else {
        // this.status=false;
        // this.errorMsg=result.msg;
        // this.alertService.error(result.msg, { keepAfterRouteChange: true });
        this.errorHandler(result.msg);
      }
    });
  }
  errorHandler(errorMsg:string){
    this.spinner.hide();
    this.status=false;
    this.errorMsg=errorMsg;
    
  }
}
